var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgHeart = function SvgHeart(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4378 6.97513C8.8809 5.38284 6.31891 5.38284 4.76201 6.97513C3.25381 8.51761 3.25381 10.9823 4.76201 12.5248L11.8612 19.7853C11.9373 19.8631 12.0625 19.8631 12.1386 19.7853L19.2378 12.5248C20.746 10.9823 20.746 8.51761 19.2378 6.97513C17.6809 5.38284 15.1189 5.38284 13.562 6.97513L12.5362 8.0243C12.3951 8.16861 12.2017 8.24996 11.9999 8.24996C11.7981 8.24996 11.6048 8.16861 11.4636 8.0243L10.4378 6.97513ZM3.6895 5.92645C5.8348 3.7324 9.36501 3.7324 11.5103 5.92645L11.9999 6.42718L12.4895 5.92645C14.6348 3.7324 18.165 3.7324 20.3103 5.92645C22.3885 8.05187 22.3885 11.448 20.3103 13.5735L13.2111 20.834C12.5466 21.5136 11.4532 21.5136 10.7887 20.834L3.6895 13.5735C1.61131 11.448 1.61131 8.05187 3.6895 5.92645Z",
    fill: "#22282F"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgHeart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Heart.b214e56a132a07e963756226318b7806.svg";